<div mat-dialog-content class="w-full bg-white !p-0 !m-0">
  <div class="modal-title">
    <h3 class="green decoration">Registrar devolución</h3>
  </div>
  <div class="modal-inner" [formGroup]="dataForm">
    <p class="m-0 mb-3"><strong>Activo:</strong> {{ data?.type }}<ng-container *ngIf="data?.model"> - {{ data?.model }}</ng-container><ng-container *ngIf="data?.cod_asset"> ({{ data?.cod_asset }})</ng-container></p>

    <div class="form-wrapper mb-3" [class.control-invalid]="dataForm.get('condition').dirty && dataForm.get('condition').invalid">
      <span>Condición en la que se devuelve*</span>
      <select formControlName="condition">
        <option value="">Seleccione una opción</option>
        <option *ngFor="let conditionType of conditionTypes" [value]="conditionType.id">{{ conditionType.name }}</option>
      </select>
      <p *ngIf="dataForm.get('condition').dirty && dataForm.get('condition').invalid">
        <img src="../../../assets/img/x-circle.svg" alt="icon">
        <label>Este campo es necesario</label>
      </p>
    </div>

    <div class="form-wrapper mb-3" [class.control-invalid]="dataForm.get('city').dirty && dataForm.get('city').invalid">
      <span>Ciudad donde queda el almacén*</span>
      <select formControlName="city">
        <option value="">Seleccione una opción</option>
        <option *ngFor="let city of cities" [value]="city.id">{{ city.name }}</option>
      </select>
      <p *ngIf="dataForm.get('city').dirty && dataForm.get('city').invalid">
        <img src="../../../assets/img/x-circle.svg" alt="icon">
        <label>Este campo es necesario</label>
      </p>
    </div>

    <div class="form-wrapper mb-3">
      <span>Notas</span>
      <textarea formControlName="notes" placeholder="Detalles de la devolución (opcional)"></textarea>
    </div>
  </div>
</div>

<div mat-dialog-actions class="!m-0 w-full block">
  <div class="w-full flex justify-end actions_modal">
    <button mat-button type="button" (click)="dismiss()" class="btn btn-outline-accent big">Cancelar</button>
    <button mat-button type="button" (click)="submitForm()" class="btn btn-primary big">Registrar devolución</button>
  </div>
</div>
